import { atom, useAtom } from 'jotai';

import { buildBridgeUrl, needsAuthBridge } from '@/lib/utils/authBridge';

export const isLoginModalShowAtom = atom(false);
export const nextPageAfterLoginAtom = atom<string | undefined>('');

export function useLoginModal() {
  const [isLoginModalShow, setIsLoginModalShow] = useAtom(isLoginModalShowAtom);
  const [nextPageAfterLogin, setNextPageAfterLogin] = useAtom(
    nextPageAfterLoginAtom,
  );

  function closeLoginModal() {
    setIsLoginModalShow(false);
  }

  function openLoginModal(
    /**
     * @param nextPage 로그인 성공 후 이동할 페이지
     */
    nextPage?: string,
  ) {
    // 로그인 쿠키를 직접 받을 수 없는 도메인(hanghae.co)에서는 모달을 띄워도
    // 세션이 남지 않는다. 구 도메인 브릿지를 거쳐 쿠키를 넘겨받는다.
    if (needsAuthBridge()) {
      const returnPath =
        nextPage ?? `${window.location.pathname}${window.location.search}`;
      window.location.assign(buildBridgeUrl(returnPath));
      return;
    }

    if (nextPage) {
      setNextPageAfterLogin(nextPage);
    }
    setIsLoginModalShow(true);
  }

  return {
    isOpen: isLoginModalShow,
    nextPage: nextPageAfterLogin,
    close: closeLoginModal,
    open: openLoginModal,
    setNextPage: setNextPageAfterLogin,
  };
}
